import { render } from "./PrevPayList.vue?vue&type=template&id=a18e32c2"
import script from "./PrevPayList.vue?vue&type=script&lang=js"
export * from "./PrevPayList.vue?vue&type=script&lang=js"

import exportComponent from "/www/wwwroot/home/v-admin/node_modules/.store/vue-loader@16.8.3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__